var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBlur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1387,
    viewBox: "0 0 1440 1387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81,
    filter: "url(#filter0_f_8607_8793)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter1_f_8607_8793)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 419,
    cy: 504.5,
    rx: 342,
    ry: 364.5,
    fill: "url(#paint0_linear_8607_8793)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter2_f_8607_8793)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1021,
    cy: 504.5,
    rx: 342,
    ry: 364.5,
    fill: "url(#paint1_linear_8607_8793)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter3_f_8607_8793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.193 580.192C514.002 432.682 242.205 153.497 132.559 140.719C-63.7525 117.841 -35.0439 647.129 172.57 836.274C367.386 1013.76 1719.68 1195.46 1387.83 836.274C1211.29 645.18 1012.29 705.73 783.193 580.192Z",
    fill: "#0047FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8607_8793",
    x: -279,
    y: -139,
    width: 1998,
    height: 1461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 139.5,
    result: "effect1_foregroundBlur_8607_8793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8607_8793",
    x: -323,
    y: -260,
    width: 1484,
    height: 1529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_8607_8793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8607_8793",
    x: 270,
    y: -269,
    width: 1502,
    height: 1547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 204.5,
    result: "effect1_foregroundBlur_8607_8793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8607_8793",
    x: -343.35,
    y: -203.35,
    width: 2126.7,
    height: 1589.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 171.675,
    result: "effect1_foregroundBlur_8607_8793"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8607_8793",
    x1: 419,
    y1: 140,
    x2: 419,
    y2: 869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#8000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF5AF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8607_8793",
    x1: 1021,
    y1: 140,
    x2: 1021,
    y2: 869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#8000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF5AF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlur);
export default __webpack_public_path__ + "static/media/hero-blur.147ba96779892c7ef07e0344fdf326c6.svg";
export { ForwardRef as ReactComponent };